import { formatClock } from "../classesHelpers";

interface IRegTimeBannerProps {
    /** Giờ mở — đã resolve ở ClassesPage: ưu tiên đợt (`openAt`), fallback claim JWT. */
    start?: string | null;
    /** Giờ đóng — ưu tiên đợt (`closeAt`), fallback claim JWT. */
    end?: string | null;
}

/**
 * Thẻ khung giờ đăng ký (bản mobile). Giá trị bám theo ĐỢT (`reg:period:current`) giống Header
 * — ESS sửa đợt thì SV F5 thấy ngay; chỉ fallback claim JWT khi đợt chưa có dữ liệu.
 */
const RegTimeBanner = ({ start, end }: IRegTimeBannerProps) => {
    if (!start && !end) return null;

    return (
        <div className="m-timecard">
            <i className="far fa-clock m-timecard-icon" />
            <div className="m-timecard-body">
                <div className="m-timecard-row">
                    <span className="m-timecard-label">Thời gian đăng ký tín chỉ</span>
                    <span className="m-timecard-value">
                        {formatClock(start)} → {formatClock(end)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default RegTimeBanner;
